var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTheoryEmptyState = function SvgTheoryEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 262,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.661 97c23.21 0 42.024-19.305 42.024-43.117 0-23.813-18.815-43.117-42.024-43.117-23.21 0-42.024 19.304-42.024 43.117 0 23.812 18.815 43.116 42.024 43.116Z",
    fill: "url(#theory-empty-state_svg__a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#theory-empty-state_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.678 26H30.321C29.041 26 28 27.06 28 28.363v55.619L48.822 71.84a.694.694 0 0 1 .695-.005L71 84V28.363C71 27.06 69.958 26 68.678 26Z",
    fill: "url(#theory-empty-state_svg__c)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32.427a5.508 5.508 0 0 1-1.31 3.58 5.25 5.25 0 0 1-3.285 1.804c-.233.03-.467.046-.701.047H74.096a6.96 6.96 0 0 1-1.14-.097 6.624 6.624 0 0 1-4.093-2.5 6.948 6.948 0 0 1-1.415-4.667 6.904 6.904 0 0 1 1.99-4.442 6.572 6.572 0 0 1 4.373-1.937 9.52 9.52 0 0 1 4.069-4.444 9.168 9.168 0 0 1 5.855-1.04 9.293 9.293 0 0 1 5.288 2.78 9.717 9.717 0 0 1 2.595 5.485h.08a5.178 5.178 0 0 1 2.028.41 5.286 5.286 0 0 1 1.72 1.178 5.443 5.443 0 0 1 1.15 1.762c.267.66.404 1.367.404 2.08Z",
    fill: "url(#theory-empty-state_svg__d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.455 21.79a4.15 4.15 0 0 0 1.169 2.896 3.94 3.94 0 0 0 2.822 1.199h13.249a4.944 4.944 0 0 0 3.487-1.476 5.203 5.203 0 0 0 1.493-3.554 5.214 5.214 0 0 0-1.346-3.615 4.955 4.955 0 0 0-3.423-1.626 7.168 7.168 0 0 0-3.064-3.331 6.904 6.904 0 0 0-4.4-.779 6.998 6.998 0 0 0-3.974 2.086 7.316 7.316 0 0 0-1.96 4.115h-.06a3.94 3.94 0 0 0-2.82 1.195 4.148 4.148 0 0 0-1.173 2.89Z",
    fill: "url(#theory-empty-state_svg__e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 74.14c0 1.312.463 2.579 1.306 3.565a5.23 5.23 0 0 0 3.967 1.846h17.53a6.597 6.597 0 0 0 5.245-2.579 6.92 6.92 0 0 0 1.421-4.665 6.876 6.876 0 0 0-1.997-4.439 6.546 6.546 0 0 0-4.383-1.916 9.481 9.481 0 0 0-4.053-4.421 9.132 9.132 0 0 0-5.829-1.035 9.256 9.256 0 0 0-5.264 2.767 9.679 9.679 0 0 0-2.587 5.459h-.083c-.693 0-1.38.14-2.02.412a5.265 5.265 0 0 0-1.711 1.175c-.49.504-.879 1.101-1.143 1.758A5.533 5.533 0 0 0 4 74.141Z",
    fill: "url(#theory-empty-state_svg__f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.341 45.806c-.288-1.16.757-2.206 1.88-1.883 1.124.324 1.484 1.774.648 2.61-.835.837-2.24.433-2.528-.727ZM13.362 45.806c-.288-1.16.757-2.206 1.88-1.883 1.124.324 1.483 1.774.648 2.61-.835.837-2.24.433-2.528-.727ZM35.851 9.259c.307-1.307 2.167-1.307 2.474 0 .11.464.472.828.934.943 1.316.326 1.316 2.203 0 2.53-.462.114-.824.478-.934.943-.307 1.306-2.167 1.306-2.474 0a1.274 1.274 0 0 0-.934-.944c-1.316-.326-1.316-2.203 0-2.53.463-.114.825-.478.934-.942Z",
    fill: "#A9E0D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.082 89.244c0 .547-.424.936-.88.936-.457 0-.882-.389-.882-.936s.425-.936.881-.936c.457 0 .881.389.881.936Z",
    stroke: "#A9E0D4",
    strokeWidth: 2.483
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.022 77.392c.307-1.307 2.167-1.307 2.474 0 .11.464.471.828.934.943 1.316.326 1.316 2.203 0 2.53-.463.114-.825.478-.934.942-.307 1.307-2.167 1.307-2.474 0a1.274 1.274 0 0 0-.934-.943c-1.316-.326-1.316-2.203 0-2.53.462-.114.824-.478.934-.942Z",
    fill: "#A9E0D4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "theory-empty-state_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.374,
    cy: 64.353,
    rx: 2.123,
    ry: 2.178
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.013 64.353c0-.107.102-.305.36-.305v4.966c2.604 0 4.606-2.147 4.606-4.66h-4.966Zm.36-.305c.26 0 .36.198.36.305h-4.965c0 2.514 2.002 4.661 4.606 4.661v-4.966Zm.36.305c0 .109-.1.306-.36.306v-4.966c-2.603 0-4.605 2.147-4.605 4.66h4.966Zm-.36.306c-.258 0-.36-.197-.36-.306h4.966c0-2.513-2.002-4.66-4.605-4.66v4.966Z",
    fill: "#5DC0AD",
    fillOpacity: 0.4,
    mask: "url(#theory-empty-state_svg__g)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "theory-empty-state_svg__a",
    x1: 49.337,
    y1: -3.274,
    x2: 50.243,
    y2: 148.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "theory-empty-state_svg__c",
    x1: 87.5,
    y1: 20.5,
    x2: -49,
    y2: 165.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DE2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#257E6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "theory-empty-state_svg__d",
    x1: 91.389,
    y1: 46.154,
    x2: 76.094,
    y2: 18.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "theory-empty-state_svg__e",
    x1: 25.46,
    y1: 32.123,
    x2: 13.958,
    y2: 11.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "theory-empty-state_svg__f",
    x1: 27.888,
    y1: 87.817,
    x2: 12.658,
    y2: 60.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFFFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "theory-empty-state_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(11.27 15.652)",
    d: "M0 0h76.207v78.189H0z"
  })))));
};
export default SvgTheoryEmptyState;